import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

type LhcbModalAction = 'discard' | 'sign' | null;

@Component({
  selector: 'app-lhcb-migration-modal',
  templateUrl: './lhcb-migration-modal.component.html',
  styleUrls: ['./lhcb-migration-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LhcbMigrationModalComponent implements OnChanges {
  @Input() public isOpen: boolean = false;
  @Input() public couponCode: string | null = null;
  @Input() public poaPrice: number | null = null;
  @Input() public isAcknowledging: boolean = false;

  @Output() public discarded: EventEmitter<void> = new EventEmitter<void>();
  @Output() public signThePoa: EventEmitter<void> = new EventEmitter<void>();

  public activeAction: LhcbModalAction = null;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.isAcknowledging && changes.isAcknowledging.currentValue === false) {
      this.activeAction = null;
    }
  }

  public onDiscard(): void {
    if (this.isAcknowledging) {
      return;
    }
    this.activeAction = 'discard';
    this.discarded.emit();
  }

  public onSignThePoa(): void {
    if (this.isAcknowledging) {
      return;
    }
    this.activeAction = 'sign';
    this.signThePoa.emit();
  }
}
